module.exports = __webpack_public_path__ + "img/ico_social_facebook--white.95bbc7e9.svg";